export const RegimenConyugalArray =[
    {id:'BM',display:'BIENES MANCOMUNADOS'},
    {id:'BS',display:'BIENES SEPARADOS'},
]